import log from '@/lib/logger';
import type { AppDispatch, RootState } from '@/store';
import type { UnknownAction } from '@reduxjs/toolkit';
import { getChargingAuthorizations } from 'services/cs';
import type { ChargingAuthorization } from 'types/swagger';

enum ChargingAuthorizationActionTypes {
  SET_CHARGING_AUTHORIZATIONS = 'SET_CHARGING_AUTHORIZATIONS',
  SET_IS_FETCHING_CHARGING_AUTHORIZATIONS = 'SET_IS_FETCHING_CHARGING_AUTHORIZATIONS',
}

type ChargingAuthorizationsAction = {
  type: ChargingAuthorizationActionTypes;
  payload: any;
};

type ChargingAuthorizationsState = {
  chargingAuthorizations: {
    chargingAuthorizations: ChargingAuthorization[];
  };

  isFetchingChargingAuthorizations: boolean;
};

const INIT_STATE: ChargingAuthorizationsState = {
  chargingAuthorizations: {
    chargingAuthorizations: [],
  },
  isFetchingChargingAuthorizations: false,
};

export default function chargingAuthorizationsReducer(state = INIT_STATE, action: UnknownAction) {
  const { type, payload } = action;

  switch (type) {
    case ChargingAuthorizationActionTypes.SET_CHARGING_AUTHORIZATIONS: {
      return {
        ...state,
        chargingAuthorizations: {
          ...state.chargingAuthorizations,
          chargingAuthorizations: payload as ChargingAuthorization[],
        },
      };
    }
    default:
      return state;
  }
}

export const setChargingAuthorizations = (
  chargingAuthorizations: ChargingAuthorization[]
): ChargingAuthorizationsAction => ({
  type: ChargingAuthorizationActionTypes.SET_CHARGING_AUTHORIZATIONS,
  payload: chargingAuthorizations,
});

export const setIsFetchingChargingAuthorizations = (
  isFetching: boolean
): ChargingAuthorizationsAction => ({
  type: ChargingAuthorizationActionTypes.SET_IS_FETCHING_CHARGING_AUTHORIZATIONS,
  payload: isFetching,
});

export const fetchChargingAuthorizations = () => async (dispatch: AppDispatch) => {
  dispatch(setIsFetchingChargingAuthorizations(true));

  try {
    const res = await getChargingAuthorizations();
    if (res.data.results.length) {
      dispatch(setChargingAuthorizations(res.data.results));
      dispatch(setIsFetchingChargingAuthorizations(false));
      return res;
    }
    return res;
  } catch (error) {
    log.error(error);
    return error;
  } finally {
    dispatch(setIsFetchingChargingAuthorizations(false));
  }
};

export const selectChargingAuthorizations = (state: RootState) =>
  state.chargingAuthorizations.chargingAuthorizations.chargingAuthorizations;
export const selectIsFetchingChargingAuthorizations = (state: RootState) =>
  state.chargingAuthorizations.isFetchingChargingAuthorizations;
